import React from "react";
import Navbar from "../Components/Navbar";
import '../Styles/FirstLight.scss';
import {Helmet} from "react-helmet";
import Footer from "../Components/Footer.js";

function FirstLightNav() {
   return (
      <div>
      <Helmet>
         <title>Ministry Resources - Camp Connect</title>
      </Helmet>
      <div className="firstLightNavOuterContainer">
         <Navbar/>

         <div className="firstLightNavInnerContainer">

            <div className="firstLightNavTitleOuterContainer">
               <div className="firstLightNavTitleInnerContainer">
                  <div className="firstLightNavTitleText1">
                     <>Ministry Resources</>
                  </div>

                  {/* <div className="firstLightNavTitleText2">
                     <>Ministry Resources</>
                  </div> */}
               </div>
            </div>


            <div className="FLNavBoxesOuterContainer">

            <div className="FLNavPodcastBox">
               <div className="FLNavPodcastBoxInnerContainer">
                     <div className="FLNavPodcastBoxTitleText">
                        <>Podcast</>
                     </div>

                     <div className="FLNavPodcastBoxBodyText">
                        <>
                           First Light podcast is a podcast hosted by Dr. Dale Adkins. 
                           This brief devotional-style podcast encourages christians to 
                           "walk in the light"
                        </>
                     </div>

                     <div className="FLNavPodcastBoxButton">
                        <a className="FLNavPodcastBoxButtonSignUp" 
                                 href="https://www.rejoice.org/Streams/" target="_blank" rel="noreferrer">
                           <button>
                              Listen
                           </button>                     
                        </a> 
                     </div>
               </div>
            </div>


            <div className="FLNavBlogBox">
               <div className="FLNavBlogBoxInnerContainer">
                     <div className="FLNavBlogBoxTitleText">
                        <>Blog</>
                     </div>

                     <div className="FLNavBlogBoxBodyText">
                        <>
                           Throughout the year, there’s always something happening at the property, 
                           whether it’s a long-loved tradition or a brand-new event. 
                           Read up on our campers as they engage camp life, get to know our faculty, 
                           and celebrate camp alumni who are influencing their world for Christ.
                        </>
                     </div>

                     <div className="FLNavBlogBoxButton">
                        <a className="FLNavBlogBoxButtonSignUp" 
                                 href="https://news.pcci.edu/" target="_blank" rel="noreferrer">
                           <button>
                              Articles
                           </button>                     
                        </a> 
                     </div>
               </div>
            </div>



            <div className="FLNavSermonAudioBox">
               <div className="FLNavSermonAudioBoxInnerContainer">
                     <div className="FLNavSermonAudioBoxTitleText">
                        <>Sermon Audio</>
                     </div>

                     <div className="FLNavSermonAudioBoxBodyText">
                        <>
                        Chapel provides a time of encouragement for campers 
                        as preachers from around the country share truths from the Bible.
                        </>
                     </div>

                     <div className="FLNavSermonAudioBoxButton">
                        <a className="FLNavSermonAudioBoxButtonSignUp" 
                                 href="https://www.pcci.edu/campus-life/faith-service/chapel-messages.aspx" target="_blank" rel="noreferrer">
                           <button>
                              Listen
                           </button>                     
                        </a> 
                     </div>
               </div>
            </div>


            <div className="FLNavEmailDevBox">
               <div className="FLNavEmailDevBoxInnerContainer">
                     <div className="FLNavEmailDevBoxTitleText">
                        <>Email Devotionals</>
                     </div>

                     <div className="FLNavEmailDevBoxBodyText">
                        <>
                           Don't have time to listen to a whole podcast?
                           Subscribe to our email devotionals to read quick thoughts and 
                           quotes from our podcast!
                        </>
                     </div>

                     <div className="FLNavEmailDevBoxButton">
                        <a className="FLNavEmailDevBoxButtonSignUp" 
                                 href="https://www.pcci.edu/current-students/parents/subscribe-enews-letter.aspx" target="_blank" rel="noreferrer">
                           <button>
                              Sign Up
                           </button>                     
                        </a> 
                     </div>
               </div>
            </div>

            </div>

         </div>









      </div>
      <Footer/>
      </div>
   )
};

export default FirstLightNav;
